import { UIAbstractSlider, UISliderProperties } from "./UIAbstractSlider";

export interface UIVerticalSliderProperties extends UISliderProperties {
	y?: undefined;
}

export class UIVerticalSlider extends UIAbstractSlider<UIVerticalSliderProperties> {

	protected updateSlider() {
		let barPadding = this.barSize - this.barInnerSize;
		let barLength = this.height - this.barInnerSize * 2 - barPadding * 2;
		this.value = (this.mouseY - this.barInnerSize - barPadding) / barLength;
		this.value = this.value < 0 ? 0 : (this.value > 1) ? 1 : this.value;
	}

	protected redrawBar() {
		let { width, height } = this;

		let barPadding = this.barSize - this.barInnerSize;

		let barLength = height - this.barInnerSize * 2 - barPadding * 2;

		this.bar.clear();
		this.bar.beginFill(this.barColor, 1);
		this.bar.drawCircle((width / 2), this.barSize, this.barSize);
		this.bar.drawRect((width / 2) - this.barSize, this.barSize, this.barSize * 2, height - this.barSize * 2);
		this.bar.drawCircle((width / 2), height - this.barSize, this.barSize);
		this.bar.endFill();

		this.bar.beginFill(this.barInnerColor, 1);
		this.bar.drawCircle((width / 2), this.barInnerSize + barPadding, this.barInnerSize);
		this.bar.drawRect((width / 2) - this.barInnerSize, this.barInnerSize + barPadding, this.barInnerSize * 2, barLength);
		this.bar.drawCircle((width / 2), height - this.barInnerSize - barPadding, this.barInnerSize);
		this.bar.endFill();
	}

	protected redrawSlider() {
		let { width, height } = this;

		let barPadding = this.barSize - this.barInnerSize;
		let barLength = height - this.barInnerSize * 2 - barPadding * 2;

		let barPosition = barLength * this.value;

		let sliderColor = this.mouseDown ? this.sliderActiveColor : this.sliderColor;
		let sliderInnerColor = (this.mouseOver || this.mouseDown) ? this.sliderHoverColor : this.sliderInnerColor;

		this.slider.clear();
		this.slider.beginFill(sliderColor, 1);
		this.slider.drawCircle(0, 0, this.barSize);
		this.slider.endFill();

		this.slider.beginFill(sliderInnerColor, 1);
		this.slider.drawCircle(0, 0, this.barInnerSize);
		this.slider.endFill();

		this.slider.x = (width / 2);
		this.slider.y = barPosition + this.barInnerSize + barPadding;
	}

	public get width() { return this.barSize * 2; }
	public get height() { return this.parent.height; }

	public updateSliderPosition(value: number) {
		let barPadding = this.barSize - this.barInnerSize;
		let barLength = this.height - this.barInnerSize * 2 - barPadding * 2;
		let barPosition = barLength * value;
		this.slider.y = barPosition + this.barInnerSize + barPadding;
	}
}
